import { render } from "./ActionGroups.vue?vue&type=template&id=a679f0e2"
import script from "./ActionGroups.vue?vue&type=script&lang=js"
export * from "./ActionGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__